module.exports = __webpack_public_path__ + "static/media/star.2d84eb83.svg";